import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import img from "../../../assets/events/internal Events Images/tips4/tips1.webp"
import img1 from "../../../assets/events/internal Events Images/tips4/tips2.webp"
import img2 from "../../../assets/events/internal Events Images/tips4/tips3.webp"
import img3 from "../../../assets/events/internal Events Images/tips4/tips4.webp"

import MainSubHeading from "../../Sub-Heading/MainSubHeading";
export default function dstVisit() {
  const subheadingData = "Events";
  return (
    
    <Container>
      <MainSubHeading subheading={subheadingData} />
      <div className="mt-4">

      <h1 className='text-center'>IHub-Data participated in TIPS 4.0 at IIT Bombay</h1>
      <p>
      IHub-Data participated in TIPS 4.0 (the 4th National Workshop on Technology Innovation in Cyber-Physical Systems) at IIT Bombay on May 13 and 14. 5 Technology Innovation Hubs under National Mission on Interdisciplinary Cyber Physical Systems (NM-ICPS) sponsored by India DST came together for the event. DST Secretary Prof Abhay Karandikar inaugurated the event while the NM-ICPS leadership including Chairman Kris Gopalakrishnan and Dr Akhilesh Gupta were present during the workshop. IHub-Data CEO Dr Jay Mookherje, CTO Dr Veera Ganesh Yalla, and Healthcare lead Prof Bapi Raju gave a presentation on our journey so far and roadmap for future. Our startups Eranext and Padmaseetha put up stalls at the conference and participated in the presentation session to pitch before VCs.
 
      </p>
      
      </div>

      <div className="img-content text-center">
        <Row>
          <Col className='p-3' sm={12} md={6}>
      <img src={img} alt='' className='img-fluid' />

          </Col>
          <Col className='p-3' sm={12} md={6}>
            
      <img src={img1} alt='' className='img-fluid'/>
          </Col>
          <Col className='p-3' sm={12} md={6}>
      <img src={img2} alt='' className='img-fluid'/>
            
          </Col>
          <Col className='p-3' sm={12} md={6}>
      <img src={img3} alt='' className='img-fluid'/>
            
          </Col>
        </Row>

      </div>
      </Container>
    
  )
}
